import { Turbo } from '@hotwired/turbo-rails'

export function renderWalkResponse (result) {
  if (result.stream) {
    Turbo.renderStreamMessage(result.stream)
  } else {
    window.location.assign(result.url)
  }
}

export async function currentLocation () {
  if (!navigator.geolocation) return null

  return new Promise(resolve => {
    navigator.geolocation.getCurrentPosition(position => resolve({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      accuracy: position.coords.accuracy,
      recorded_at: new Date(position.timestamp).toISOString()
    }), () => resolve(null), { enableHighAccuracy: true, maximumAge: 0, timeout: 8000 })
  }).catch(() => null)
}

export async function sendJSON (url, method, data) {
  const response = await window.fetch(url, {
    method,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
    },
    body: JSON.stringify(data)
  })
  if (!response.ok || response.redirected) {
    const result = await response.json().catch(() => ({}))
    throw new Error(result.error || 'Could not save. Check your connection and sign-in, then retry.')
  }
  return response.status === 204 ? null : response.json()
}
